import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getTransportations(filterBy, view, currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getTransportations`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },
}